import React, { Suspense } from "react"
import { PathiconProps } from "./ExpensivePathicon"

const LazyPathicon = React.lazy(
  () => import("./ExpensivePathicon" /* webpackChunkName: "Pathicons" */)
)

const Pathicon = React.forwardRef<SVGSVGElement, PathiconProps>(
  (props, ref) => (
    <Suspense fallback={null}>
      <LazyPathicon ref={ref} {...props} />
    </Suspense>
  )
)

export default Pathicon
